import { useSplitEnabled } from '@buffer-mono/features'

import type { CommunityTab } from '../../types'

/** Gates the Messages tab. Also drives its alpha/beta badge. */
export const DMS_TAB_SPLIT = 'geid-cet-dms-tab'

/**
 * Tabs the actor may reach, in render order. Comments is always present, so
 * the list is never empty and `DEFAULT_TAB` always resolves.
 *
 * Each optional tab stays out while its split SDK is not ready, so a tab never
 * appears and then disappears on the same page load.
 */
export const useAvailableTabs = (): CommunityTab[] => {
  const { isEnabled: isMentionsTabEnabled, isReady: isMentionsReady } =
    useSplitEnabled('geid-cet-mentions-tab')
  const { isEnabled: isDmsTabEnabled, isReady: isDmsReady } =
    useSplitEnabled(DMS_TAB_SPLIT)

  const tabs: CommunityTab[] = ['comments']

  if (isMentionsReady && isMentionsTabEnabled) {
    tabs.push('mentions')
  }

  if (isDmsReady && isDmsTabEnabled) {
    tabs.push('dms')
  }

  return tabs
}
